import { Button, makeStyles } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import { Endpoint } from "../../api/base";
import CustomLoader from "../../components/CustomLoader";
import { generateQuickGuid } from "../../components/shared/helpers/helper";
import AddClient from "./AddClient";
import ClientList from "./ClientList";
import { viewportContext } from "../../context/ViewportContext";
import { Typography } from "@mui/material";
import { tokens } from "../../theme/tokens";

const useStyle = makeStyles((theme) => ({
  caseContainer: {
    [theme.breakpoints.down("md")]: {
      width: "90%",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: tokens.space[3],
    padding: tokens.space[4],
  },
  title: {
    margin: "0px",
    fontWeight: 600,
    color: tokens.color.text.primary,
  },
  segmented: {
    display: "inline-flex",
    border: `1px solid ${tokens.color.border.default}`,
    borderRadius: tokens.radius.sm,
    overflow: "hidden",
  },
  segItem: {
    border: "none",
    borderRadius: "0px",
    textTransform: "none",
    fontWeight: 500,
    padding: `${tokens.space[2]} ${tokens.space[4]}`,
    color: tokens.color.text.secondary,
    backgroundColor: "transparent",
    "&:hover": { backgroundColor: tokens.color.surface.hover },
  },
  segItemActive: {
    backgroundColor: tokens.color.brand.primaryAction,
    color: tokens.color.brand.onPrimary,
    "&:hover": { backgroundColor: tokens.color.brand.primaryAction },
  },
  content: {
    padding: `0px ${tokens.space[4]} ${tokens.space[6]}`,
  },
}));

const initialState = {
  client_name: "",
  street_address: "",
  city: "",
  zip_code: "",
  abbreviation: "",
  state: "",
  client_id: "",
  contacts: [
    {
      id: generateQuickGuid("client"),
      first_name: "",
      last_name: "",
      phone: "",
      email: "",
    },
  ],
  hourly_rate: 0,
  database_search_rate: 0,
  local_investigator_rate: 0,
  local_investigator_mileage_rate: 0,
};
function ClientView() {
  const classes = useStyle();
  const [view, SetView] = useState(true);
  const [clientList, setClientList] = useState([]);
  const [initState, setInitState] = useState(initialState);
  const [open, setOpen] = useState(false);
  const { tallScreen } = useContext(viewportContext);

  const getClients = () => {
    setOpen(true);
    Endpoint.getClients()
      .then((res) => {
        setClientList(res.data);
        setOpen(false);
      })
      .catch((err) => {
        console.log(err);
        setOpen(false);
      });
  };
  useEffect(() => {
    getClients();
  }, []);

  const setInitialValues = (val) => {
    setInitState(val);
    SetView(false);
  };

  const getTitle = () =>
    view
      ? "Clients Information"
      : initState.client_id === ""
        ? "Add Client"
        : "Update Client Information";

  return (
    <div>
      <div className={classes.header}>
        <Typography variant="h6" className={classes.title}>
          {getTitle()}
        </Typography>
        <div
          className={classes.segmented}
          role="group"
          aria-label="Clients view"
        >
          <Button
            className={`${classes.segItem} ${view ? classes.segItemActive : ""}`}
            aria-pressed={view}
            onClick={() => {
              SetView(true);
            }}
          >
            Client List
          </Button>
          <Button
            className={`${classes.segItem} ${!view ? classes.segItemActive : ""}`}
            aria-pressed={!view}
            onClick={() => {
              SetView(false);
              setInitState(initialState);
            }}
          >
            Add Client
          </Button>
        </div>
      </div>

      <div
        className={`${classes.content} ${
          tallScreen ? "" : classes.caseContainer
        }`}
      >
        {view ? (
          <ClientList
            setInitialValues={setInitialValues}
            clientList={clientList}
            loading={open}
          />
        ) : (
          <AddClient initState={initState} />
        )}
      </div>
    </div>
  );
}

export default ClientView;
